'use strict';

module.exports = {
    loadForm: function () {
        // Handle Variant/Product updates (e.g., color/size changes)
        $('body').on('product:updateAddToCart', function (e, response) {
            // Check if the response contains the new HTML for the Back In Stock form
            if (response.product.backInStockForm) {
                let $target = response.$productContainer.find('.prices-add-to-cart-actions');
                let $existingForm = $('.back-in-stock-form', response.$productContainer);

                // Remove existing form to prevent duplicates before appending the new one
                if ($existingForm.length) {
                    $existingForm.remove();
                }
                // Append the newly rendered form HTML from the server response
                $target.append(response.product.backInStockForm);
            } else {
                // Product is back in stock, show Add to Cart and ensure form is removed
                $('.back-in-stock-form', response.$productContainer).remove();
            }
        });

        // Handle AJAX submission of the Back In Stock request
        $('body').on('submit', '.back-in-stock-form', function (e) {
            e.preventDefault();
            let $form = $(this);
            let url = $form.attr('action');
            let data = $form.serialize();

            $.ajax({
                url: url,
                data: data,
                method: 'POST',
                success: function (data) {
                    if (data.success) {
                        // Hide the input container and show success message
                        $form.find('#backInStockContainer').collapse('hide');
                        $form.find('.back-in-stock-toggle').addClass('d-none');
                        $form.find('.js-backinstock-success-message').removeClass('d-none');
                    } else {
                        // Display server-side validation error (e.g., invalid email)
                        $('.warn', $form).removeClass('d-none').html(data.message);
                    }
                },
                error: function (err) {
                    // Fallback error for network/server issues
                    $('.warn', $form).removeClass('d-none').html('An error occurred. Please try again.');
                }
            });
        });
    }
};